module.exports = __webpack_public_path__ + "static/media/done.ee336ecd.svg";